import { c as _c } from "react/compiler-runtime";
import { DatepickerCalendarLocaleType, DatepickerPropertiesType } from "@website/ui/datepicker/datepicker.types";
import { convertDate } from "@website/ui/datepicker/datepicker.utils";
import { useState } from "react";
export const useCalendarLocale = properties => {
  const $ = _c(14);
  const {
    value,
    onChange,
    initialCalendarLocale
  } = properties;
  const [calendarLocale, setCalendarLocale] = useState(initialCalendarLocale || "persian");
  let t0;
  if ($[0] !== onChange || $[1] !== value) {
    t0 = calendarLocale_0 => {
      const convertedDate = value.map(item => convertDate(item, calendarLocale_0));
      onChange(convertedDate, calendarLocale_0);
      setCalendarLocale(calendarLocale_0);
    };
    $[0] = onChange;
    $[1] = value;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const onLocaleChange = t0;
  let t1;
  if ($[3] !== onLocaleChange) {
    t1 = onLocaleChange.bind(null, "gregorian");
    $[3] = onLocaleChange;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== onLocaleChange) {
    t2 = onLocaleChange.bind(null, "persian");
    $[5] = onLocaleChange;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== onLocaleChange) {
    t3 = onLocaleChange.bind(null, "hijri");
    $[7] = onLocaleChange;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== calendarLocale || $[10] !== t1 || $[11] !== t2 || $[12] !== t3) {
    t4 = {
      calendarLocale,
      changeCalendarLocaleToGregorian: t1,
      changeCalendarLocaleToPersian: t2,
      changeCalendarLocaleToHijri: t3
    };
    $[9] = calendarLocale;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};